export default __webpack_public_path__ + "static/media/logo copy 1.964eeb4f.png";